// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteBaustelleNachtrag(): (
  baustellenId: string,
  nachtragId: string
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (baustellenId, nachtragId) =>
      (await getAPI()).baustellen.deleteBaustelleNachtrag({
        baustellenId,
        nachtragId,
      }),
    [getAPI]
  );
}
